define('jquery.1508.changeBackground',['jquery'],
function ($) {
	var screenMode = 'desktop'
	if ($('.frontpage').length > 0) {
		var imageSrc = $('body').data('background'),
			mobileSrc = $('body').data('mobilebackground'),
			$body = $('body');

		if (Modernizr.mq('only screen and (max-width: 768px)')) {
			//$('.main').prepend(template);
			$body.css({ 'background-image': 'url('+mobileSrc+')' });
			screenMode = 'tablet';
		} else {
			$body.css({ 'background-image': 'url('+imageSrc+')' });
		}

		$(window).resize(function () {
			//Resize from desktop to mobile
			if (Modernizr.mq('only screen and (max-width: 768px)') && screenMode != 'tablet') {
				$('body').css({ 'background-image': 'url('+mobileSrc+')' });
				screenMode = 'tablet';
			}
			else if (Modernizr.mq('only screen and (min-width: 769px)') && screenMode != 'desktop'){
				$('body').css({ 'background-image': 'url(' + imageSrc + ')' });
				screenMode = 'desktop';
			}
		});
	}
});
